import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './EmailVerification.css'; // Import the CSS file

const EmailVerification = () => {
    const [verificationStatus, setVerificationStatus] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const token = new URLSearchParams(location.search).get('token');
        if (token) {
            verifyEmail(token);
        }
    }, [location]);

    const verifyEmail = async (token) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/verify?token=${token}`);
            const data = await response.json();
            if (response.ok) {
                setVerificationStatus(data.message);
                setTimeout(() => navigate('/signin'), 3000);
            } else if (response.status === 400) {
                // Handle 400 response specifically
                setVerificationStatus(data.error || 'Missing or invalid token in email verification request');
            } else {
                setVerificationStatus(data.message || 'Failed to verify email. Please try again.');
            }
        } catch (error) {
            setVerificationStatus('An error occurred during verification.');
        }
    };

    return (
        <div className="email-verification-container">
            <h1 className="email-verification-title">Email Verification</h1>
            <p className="verification-status">{verificationStatus}</p>
        </div>
    );
};

export default EmailVerification;
